import type { FC } from 'react'
import { useDealFilters } from '../../DealFiltersProvider'
import MobileHeaderButton from './MobileHeaderButton'
import HeadlessModal from '@g4g/ui/src/adopted/HeadlessModal'
import { useBoolean } from 'react-use'
import ClearAllButton from './ClearAllButton'
import CartButton from '../../../shopping-cart/buttons/CartButton'
import MobileDisclosure from './MobileDisclosure'
import SideFilter from '../../../shared/SideFilter'
import type { TickFilter } from '@g4g/utils/src/types'

const MobileFilters: FC<{ category: TickFilter[]; resource: TickFilter[] }> = ({
  category,
  resource,
}) => {
  const [isOpen, toggleIsOpen] = useBoolean(false)
  const { categories, resources } = useDealFilters()
  const activeFiltersCount = categories.size + resources.size

  return (
    <>
      <MobileHeaderButton
        data-cy="shop-mobile-filters-toggle-modal-btn"
        btnType="filter"
        active={activeFiltersCount > 0}
        onClick={() => toggleIsOpen(true)}
      >{`Filters ${activeFiltersCount}`}</MobileHeaderButton>
      <HeadlessModal
        mobileOnly
        title="Filters"
        isOpen={isOpen}
        closeModal={() => toggleIsOpen(false)}
        modalFooter={
          <div className="flex w-full space-x-4">
            <ClearAllButton />
            <CartButton
              data-cy="shop-filter-modal-done-btn"
              className="w-1/2 h-12 text-lg font-normal"
              onClick={() => toggleIsOpen(false)}
            >
              Done
            </CartButton>
          </div>
        }
      >
        <div className="flex flex-col space-y-2">
          <MobileDisclosure
            data-cy="shop-mobile-filters-disclosure-deals"
            defaultOpen={activeFiltersCount === 0 || categories.size > 0}
            title="Deals"
          >
            <SideFilter trait="category" filters={category} />
          </MobileDisclosure>
          <MobileDisclosure
            data-cy="shop-mobile-filters-disclosure-resource"
            defaultOpen={resources.size > 0}
            title="Resources"
          >
            <SideFilter trait="resource" filters={resource} />
          </MobileDisclosure>
        </div>
      </HeadlessModal>
    </>
  )
}

export default MobileFilters
